import { connect } from 'react-redux';

import {
  getFeaturedBlogAction,
  getFeaturedForumAction,
  getFeaturedPodcastAction,
} from '../../actions/dashboardActions';
import {
  getFeaturedBlogIsLoading,
  getFeaturedBlogSelector,
} from '../../components/Dashboard/dashboardSelectors';
import ResourcesView from '../../components/Dashboard/ResourcesForYou/resourcesView.jsx';
import { getPracticeExamAvailable } from '../../components/PracticeExam/PracticeExamSelectors';
import { getUser } from '../../components/User/userSelectors';

const mapStateToProps = (state, ownProps) => ({
  user: getUser(state),
  featuredBlog: getFeaturedBlogSelector(state),
  featuredBlogIsLoading: getFeaturedBlogIsLoading(state),
  practiceExamAvailable: getPracticeExamAvailable(state),
});

const mapDispatchToProps = (dispatch) => ({
  getFeaturedForum: () => dispatch(getFeaturedForumAction()),
  getFeaturedPodcast: () => dispatch(getFeaturedPodcastAction()),
  getFeaturedBlog: () => dispatch(getFeaturedBlogAction()),
});

const ResourcesContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResourcesView);

export default ResourcesContainer;
